import { render, staticRenderFns } from "./download.vue?vue&type=template&id=66a97f8c&scoped=true&"
import script from "./download.vue?vue&type=script&lang=js&"
export * from "./download.vue?vue&type=script&lang=js&"
import style0 from "./download.vue?vue&type=style&index=0&id=66a97f8c&lang=less&scoped=true&"
import style1 from "./download.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a97f8c",
  null
  
)

component.options.__file = "download.vue"
export default component.exports